<template>
    <div>
        <loader v-if="loading"></loader>
        <b-row>
            <b-col cols="12" sm="12">
                <b-card class="full-width" border-variant="info">
                    <b-row
                        ><b-col cols="12" sm="12" md="6">
                            <h3>Promotion Preference</h3> </b-col
                        ><b-col
                            cols="12"
                            sm="12"
                            md="6"
                            class="d-flex justify-content-end p-0"
                        >
                            <router-link to="./basic-info">
                                <b-button
                                    variant="primary"
                                    class="float-right position-relative back-button"
                                >
                                    BACK
                                </b-button>
                            </router-link>
                        </b-col></b-row
                    >
                    <b-col class="mt-2">
                        <ValidationObserver ref="observer">
                            <b-card>
                                <b-row>
                                    <b-col cols="12" sm="12" md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Akshay Patra"
                                            :key="resetKey"
                                        >
                                            <c-input
                                                required
                                                labelText="Akshay Patra (in %)"
                                                v-model="akshayPatra"
                                            />
                                            <span
                                                class="validate-error text-danger"
                                                >{{ errors[0] }}</span
                                            >
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col>
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Akshay Patra Cashback"
                                            :key="resetKey"
                                        >
                                            <c-input
                                                required
                                                labelText="Akshay Patra Cashback (in %)"
                                                v-model="akshayPatraCashback"
                                            />
                                            <span
                                                class="validate-error text-danger"
                                                >{{ errors[0] }}</span
                                            >
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="12" md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Promo Cashback"
                                            :key="resetKey"
                                        >
                                            <c-input
                                                required
                                                labelText="Promo Cashback (in %)"
                                                v-model="promoCashback"
                                            />
                                            <span
                                                class="validate-error text-danger"
                                                >{{ errors[0] }}</span
                                            >
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col>
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Referrer Cash"
                                            :key="resetKey"
                                        >
                                            <c-input
                                                required
                                                labelText="Referrer Cash (in %)"
                                                v-model="referrerCash"
                                            />
                                            <span
                                                class="validate-error text-danger"
                                                >{{ errors[0] }}</span
                                            >
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <b-button
                                    variant="primary"
                                    class="mt-3 d-block mx-auto"
                                    @click="saveData"
                                    >SAVE</b-button
                                >
                            </b-card>
                        </ValidationObserver>
                    </b-col>
                    <b-row class="mt-3">
                        <b-col cols="12">
                            <b-card class="second">
                                <div class="table-responsive">
                                    <b-table
                                        :striped="striped"
                                        :bordered="bordered"
                                        :small="small"
                                        :hover="hover"
                                        :dark="dark"
                                        :fixed="fixed"
                                        :no-border-collapse="noCollapse"
                                        :items="items"
                                        :fields="fields"
                                        thead-class="header"
                                    >
                                        <template
                                            slot="cell(Action)"
                                            slot-scope="data"
                                        >
                                            <div class="action-inline">
                                                <b-button
                                                    size="sm"
                                                    class="mt-4 button-circle mr-2 btn-warning"
                                                    variant="primary"
                                                    v-b-modal="
                                                        `modal-${data.index}`
                                                    "
                                                >
                                                    <i
                                                        class="fa fa-pencil edit"
                                                    ></i>
                                                </b-button>
                                                <b-modal
                                                    :id="`modal-${data.index}`"
                                                    size="md"
                                                    title="Promotion Preference Edit"
                                                    centered
                                                    hide-footer
                                                    :ref="`modal-${data.index}`"
                                                    title-class="modal-title-center"
                                                >
                                                    <b-row>
                                                        <b-col>
                                                            <ValidationProvider
                                                                rules="required"
                                                                v-slot="{
                                                                    errors,
                                                                }"
                                                                name="Akshay Patra"
                                                                :key="resetKey"
                                                            >
                                                                <c-input
                                                                    required
                                                                    labelText="Akshay Patra"
                                                                    v-model="
                                                                        akshayPatraData
                                                                    "
                                                                />
                                                                <span
                                                                    class="validate-error validate-error-red"
                                                                    >{{
                                                                        errors[0]
                                                                    }}</span
                                                                >
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col>
                                                            <c-input
                                                                required
                                                                labelText="Promo Cashback"
                                                                v-model="
                                                                    promoCashbackData
                                                                "
                                                            />
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col>
                                                            <c-input
                                                                required
                                                                labelText="Referrer Cash"
                                                                v-model="
                                                                    referrerCashData
                                                                "
                                                            />
                                                        </b-col>
                                                        <b-col>
                                                            <c-input
                                                                required
                                                                labelText="Akshay Patra Cashback"
                                                                v-model="
                                                                    akshayPatraCashbackData
                                                                "
                                                            />
                                                        </b-col>
                                                    </b-row>
                                                    <b-button
                                                        variant="info"
                                                        class="mt-3 mb-3 d-block mx-auto"
                                                        @click="
                                                            UpdateData(data)
                                                        "
                                                        >UPDATE
                                                    </b-button>
                                                </b-modal>
                                                <b-button
                                                    size="sm"
                                                    class="mt-4 button-circle"
                                                    variant="danger"
                                                    @click="delete1(data)"
                                                >
                                                    <i
                                                        class="fa fa-trash bin"
                                                    ></i>
                                                </b-button>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import { mapActions, mapGetters } from "vuex";
export default {
    components: {
        ebSelect,
        cInput,
        ValidationProvider,
        ValidationObserver,
    },

    data() {
        return {
            resetKey: 0,
            striped: false,
            bordered: true,
            small: false,
            hover: true,
            dark: false,
            fixed: false,
            noCollapse: true,
            fields: [
                {
                    key: "awardType",
                    label: "Award Type",
                },
                {
                    key: "percentage",
                    label: "Percentage (in %)",
                },
                {
                    key: "Action",
                },
            ],
            akshayPatra: null,
            promoCashback: null,
            referrerCash: null,
            akshayPatraCashback: null,
            loading: false,
            akshayPatraData: 0,
            promoCashbackData: 0,
            referrerCashData: 0,
            akshayPatraCashbackData: 0,
        };
    },
    computed: {
        ...mapGetters({
            getPartnerPreferences: "partner/GetPartnerPreferences",
        }),
        awardTypeData() {
            return this.getPartnerPreferences.bonus || {};
        },
        items() {
            const format = (value) => Number(((value || 0) * 100).toFixed(2));

            return [
                {
                    awardType: "Akshay Patra",
                    percentage: format(this.awardTypeData?.akshayPatra),
                },
                {
                    awardType: "Akshay Patra Cashback",
                    percentage: format(this.awardTypeData?.akshayPatraCashback),
                },
                {
                    awardType: "Promo Cashback",
                    percentage: format(this.awardTypeData?.promoCashback),
                },
                {
                    awardType: "Referrer Cash",
                    percentage: format(this.awardTypeData?.referrerCash),
                },
            ];
        },
    },
    methods: {
        ...mapActions({
            updatePartnerPreference: "partner/updatePartnerPreferences",
            getPreferenceAction: "partner/getPartnerPreferences",
        }),

        async UpdateData(data) {
            const payload = {
                UPIID: "44564676476467770",
                returnPolicy: {
                    isEnabled: true,
                    typeAccepeted: "Both",
                    ValidityDays: 7,
                    description: "Valid for 7 days only",
                    returnCharges: 45,
                },
                cancellationPolicy: {
                    isEnabled: true,
                    ValidityHours: 48,
                    description: "Valid for 48 hours only",
                    cancellationCharges: 50,
                },
                bonus: {
                    akshayPatra: this.akshayPatraData / 100,
                    promoCashback: this.promoCashbackData / 100,
                    referrerCash: this.referrerCashData / 100,
                    akshayPatraCashback: this.akshayPatraCashbackData / 100,
                },
                partner: this.$route.params.id,
            };
            await this.updatePartnerPreference(payload).then(() => {
                this.$swal({
                    title: "Success",
                    text: "Promotion Updated successfully!!",
                    type: "success",
                });
            });
            await this.getPreference();
            this.$refs[`modal-${data.index}`].hide();
        },
        async saveData() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            const payload = {
                UPIID: "44564676476467770",
                returnPolicy: {
                    isEnabled: true,
                    typeAccepeted: "Both",
                    ValidityDays: 7,
                    description: "Valid for 7 days only",
                    returnCharges: 45,
                },
                cancellationPolicy: {
                    isEnabled: true,
                    ValidityHours: 48,
                    description: "Valid for 48 hours only",
                    cancellationCharges: 50,
                },
                bonus: {
                    akshayPatra: this.akshayPatra / 100,
                    promoCashback: this.promoCashback / 100,
                    referrerCash: this.referrerCash / 100,
                    akshayPatraCashback: this.akshayPatraCashback / 100,
                },
                partner: this.$route.params.id,
            };
            await this.updatePartnerPreference(payload).then(() => {
                this.$swal({
                    title: "Success",
                    text: "Promotion Created successfully!!",
                    type: "success",
                });
            });
            await this.getPreference();
            this.akshayPatra = null;
            this.promoCashback = null;
            this.referrerCash = null;
            this.akshayPatraCashback = null;
            this.resetKey++;
        },

        delete1(data) {
            this.$swal({
                title: "Delete this award ?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    let payload = {
                        UPIID: "44564676476467770",
                        returnPolicy: {
                            isEnabled: true,
                            typeAccepeted: "Both",
                            ValidityDays: 7,
                            description: "Valid for 7 days only",
                            returnCharges: 45,
                        },
                        cancellationPolicy: {
                            isEnabled: true,
                            ValidityHours: 48,
                            description: "Valid for 48 hours only",
                            cancellationCharges: 50,
                        },
                        bonus: {
                            akshayPatra: 0,
                            promoCashback: 0,
                            referrerCash: 0,
                            akshayPatraCashback: 0,
                        },
                        partner: this.$route.params.id,
                    };
                    if (data.index == 0) {
                        payload.bonus.akshayPatra = 0;
                        payload.bonus.akshayPatraCashback =
                            this.awardTypeData?.akshayPatraCashback;
                        payload.bonus.promoCashback =
                            this.awardTypeData?.promoCashback;
                        payload.bonus.referrerCash =
                            this.awardTypeData?.referrerCash;
                    }
                    if (data.index == 1) {
                        payload.bonus.akshayPatra =
                            this.awardTypeData?.akshayPatra;
                        payload.bonus.akshayPatraCashback = 0;
                        payload.bonus.promoCashback =
                            this.awardTypeData?.promoCashback;
                        payload.bonus.referrerCash =
                            this.awardTypeData?.referrerCash;
                    }
                    if (data.index == 2) {
                        payload.bonus.akshayPatra =
                            this.awardTypeData?.akshayPatra;
                        payload.bonus.akshayPatraCashback =
                            this.awardTypeData?.akshayPatraCashback;
                        payload.bonus.promoCashback = 0;
                        payload.bonus.referrerCash =
                            this.awardTypeData?.referrerCash;
                    }
                    if (data.index == 3) {
                        payload.bonus.akshayPatra =
                            this.awardTypeData?.akshayPatra;
                        payload.bonus.akshayPatraCashback =
                            this.awardTypeData?.akshayPatraCashback;
                        payload.bonus.promoCashback =
                            this.awardTypeData?.promoCashback;
                        payload.bonus.referrerCash = 0;
                    }

                    this.updatePartnerPreference(payload)
                        .then((result) => {
                            this.$toasted.success(
                                "Promotion Deleted Successfully",
                            );
                            this.getPreference();
                            this.$refs["modal"].hide();
                            this.loading = true;
                        })
                        .catch((err) => {
                            console.error("Delete failed:", err);
                        });
                }
            });
        },

        getPreference() {
            this.getPreferenceAction(this.$route.params.id).then((res) => {
                const data = res && res?.response ? res?.response?.bonus : {};
                this.akshayPatraData = data?.akshayPatra * 100 || 0;
                this.promoCashbackData = data?.promoCashback * 100 || 0;
                this.referrerCashData = data?.referrerCash * 100 || 0;
                this.akshayPatraCashbackData =
                    data?.akshayPatraCashback * 100 || 0;
            });
        },
    },
    async mounted() {
        if (this.partnerAllData == null) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        await this.getPreference();
    },
};
</script>

<style>
#customers {
    font-family: "Lato";
    border-collapse: collapse;
    width: 100%;
}

#customers td,
#customers th {
    border: 1px solid #ddd;
    padding: 8px;
}

#customers tr:nth-child(even) {
    background-color: #f2f2f2;
}

#customers tr:hover {
    background-color: #ddd;
}

#customers th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #ddd;
    color: black;
}

.modal-header .close {
    color: black !important;
}

.modal-title-center {
    width: 100%;
    text-align: center;
    margin-left: -8px;
}

.back-button {
    right: 37px;
}

.validate-error-red {
    color: red;
}

@media (max-width: 576px) {
    .back-button {
        width: 70px;
        padding: 4px 0;
        text-align: center;
    }
}

.action-inline {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    white-space: nowrap;
}

/* Normalize button size */
.action-inline .btn {
    width: 36px;
    height: 36px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* Remove mobile-only stacking behavior */
@media (max-width: 576px) {
    .action-inline {
        flex-wrap: nowrap;
    }

    .action-inline .btn {
        margin-top: 0 !important;
    }
}
</style>

<style scoped>
.btn-warning {
    background: #fe7b08 !important;
    border-color: #fe7b08 !important;
}
.edit {
    color: white !important;
}
</style>
